import { z } from 'zod';

export const editRegistrationSchema = z.object({
	comment: z.string().min(1, 'Comment is required')
});

export type EditRegistrationData = z.infer<typeof editRegistrationSchema>;
